PJQ.views.history = {};

PJQ.views.history.HistoryTimelineModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'modal-history-timeline'),
        width: 600,
        maxWidth: '90%',
        isShowCloseButton: true
    },
    events: {
        'click .btn-notification-link': 'copyNotificationLink',
        'click .btn-notification-resend': 'resendNotification'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;

        if (this.options.items != null) {
            this.items = this.options.items;
        } else {
            this.items = [];
        }

        if (this.collection != null && !this.collection.isFetched) {
            await this.collection.fetch();
            _.each(this.collection.models, (item) => {
                this.items.push({
                    action: item.getActionName(),
                    description: item.getDescription(),
                    date: item.get('createdOn'),
                    person: item.get('person')
                });
            });
        }

        this.isFetched = true;
        this.render();
    },
    afterRender: function () {
        new PJQ.views.history.HistoryTimeline({
            el: this.$('.history-outer'),
            items: this.items
        });
    },
    renderData: function () {
        return {
            options: this.options,
            isFetched: this.isFetched
        };
    }
});

PJQ.views.history.HistoryTimeline = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'history-timeline'),
        subTemplates: {},
    },
    renderData: function () {
        return {
            items: this.options.items
        };
    },
    afterRender: function () {

    }
});
